import { Controller } from "@hotwired/stimulus";
import "./component.scss";

export default class extends Controller {
  static targets = ["checkbox", "content"];
  static values = { mode: String };

  connect() {
    this.apply();

    // Enable transitions only after the initial state has been applied, so the
    // optional content doesn't animate open/closed on page load.
    requestAnimationFrame(() => {
      if (this.hasContentTarget) {
        this.contentTarget.toggleAttribute("data-ready", true);
      }
    });
  }

  toggle() {
    this.apply();
  }

  apply() {
    if (!this.hasContentTarget || !this.hasCheckboxTarget) return;

    const active = this.checkboxTarget.checked;
    this.inputs.forEach((el) => (el.disabled = !active));

    if (this.modeValue === "hide") {
      this.contentTarget.toggleAttribute("data-collapsed", !active);
    } else {
      this.contentTarget.toggleAttribute("data-inactive", !active);
    }
  }

  get inputs() {
    return this.contentTarget.querySelectorAll(
      "input, select, textarea, button",
    );
  }
}
